import { NgModule } from '@angular/core';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { AuthenticationGuard } from './guard/authentication.guard';
import { CommonModule } from '@angular/common';



@NgModule({
  imports: [RouterModule,CommonModule],
  declarations: [FooterComponent],
  exports: [FooterComponent],
  providers: [AuthenticationGuard],
})
export class CoreModule {}
